var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-leadchecklisttitle"},[_c('div',{staticClass:"title-block"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('span',{staticClass:"body-2",domProps:{"innerHTML":_vm._s(_vm.subtitle)}}):_vm._e()]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }